import React, { useEffect, useState, useRef, useCallback } from "react";
import { getQuestionOptions, createFormCategory, createFormQuestion, updateFormQuestion, getCustomFormById, deleteFormQuestion, removeFormCategory } from "../../state/customFormsSlice";
import { useSelector, useDispatch } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch';
import CreatableSelect from 'react-select/creatable'
import { components } from "react-select";
import classes from "./customForms.module.css"
import Overlay from "react-bootstrap/Overlay";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Tooltip from "react-bootstrap/Tooltip";

function QuestionModal({ questionToEdit, setQuestionToEdit, showQuestionModal, setShowQuestionModal, formId, clientId }) {
    let dispatch = useDispatch();
    let statusDispatch = useApiStatusDispatch();
    const categories = useSelector(state => state.customForms.questionCategories)
    const answerTypes = useSelector(state => state.customForms.answerType)
    const [categoryIsLoading, setCategoryIsLoading] = useState(false);
    const [questionType, setQuestionType] = useState("");
    const [questionText, setQuestionText] = useState("");
    const [measurement, setMeasurement] = useState("");
    const [tempCategories, setTempCategories] = useState([]);

    const [chosenCategory, setChosenCategory] = useState(undefined)
    const [chosenAnswerType, setChosenAnswerType] = useState("")
    const [chosenSubAnswerType, setChosenSubAnswerType] = useState("")
    const [category, setNewCategory] = useState("");
    const [placeholderText, setPlaceholderText] = useState("")
    const [subPlaceholderText, setSubPlaceholderText] = useState("")
    const [questionId, setQuestionId] = useState("");
    const [tempAnswerTypes, setTempAnswerTypes] = useState([]);

    const [questionCreateLoad, setQuestionCreateLoad] = useState(false);
    const [questionUpdateLoad, setQuestionUpdateLoad] = useState(false);

    const isTrainer = useSelector(state => state.users.current_user.account_type === "trainer");
    const isGym = useSelector(state => state.users.current_user.account_type === "gym");

    const isTrainerOrGym = isTrainer || isGym


    useEffect(() => {
        if (questionToEdit) {
            setQuestionText(questionToEdit.question)
            setChosenCategory(({
                value: questionToEdit.category_id,
                label: questionToEdit.category_name
            }))
            setQuestionId(questionToEdit.question_id)
            setChosenAnswerType(questionToEdit.answer_array[0]?.answer_type_id)
            setPlaceholderText(questionToEdit.answer_array[0]?.placeholder_text)

            setSubPlaceholderText(questionToEdit.answer_array[1]?.placeholder_text)

            if (questionToEdit.answer_array[1]?.answer_type_id == "9" || questionToEdit.answer_array[1]?.answer_type_id == "10") {
                setMeasurement(questionToEdit.answer_array[1]?.answer_type_id)
            } else if (questionToEdit.answer_array[1]?.answer_type_id) {
                setChosenSubAnswerType(questionToEdit.answer_array[1]?.answer_type_id)
            }
        } else {
            setQuestionType("")
            setQuestionText("")
            setMeasurement("")
            setChosenCategory(undefined)
            setQuestionId("")
            setChosenAnswerType("")
            setPlaceholderText("")
            setSubPlaceholderText("")
            setMeasurement("")
            setChosenSubAnswerType("")
        }
    }, [questionToEdit])

    useEffect(() => {
        if (isTrainerOrGym) {
            let payload = {
                action: "getQuestionOptions",
            }
            dispatch(getQuestionOptions(payload))
        }
    }, [])

    useEffect(() => {
        setTempCategories(categories);
        setTempAnswerTypes(answerTypes);
    }, [categories, answerTypes])


    function createQuestion() {
        if (!questionText) {
            return alert("Question text required")
        }
        if (!chosenCategory) {
            return alert("category required")
        }
        if (!chosenAnswerType) {
            return alert("Answer type required")
        }
        let payload = {
            "question": questionText,
            "form_id": formId,
            "category_id": chosenCategory?.value,
            "answer_type_id": chosenAnswerType,
            "placeholder_text": placeholderText,
            action: "createFormQuestion"
        }
        if (chosenSubAnswerType) {
            payload.second_answer_type_id = chosenSubAnswerType
            payload.second_placeholder_text = subPlaceholderText

        } else if (measurement) {
            payload.second_answer_type_id = measurement;
        }

        setQuestionCreateLoad(true)

        statusDispatch(createFormQuestion(payload), "question", "create").then(
            res => {
                setShowQuestionModal(false)
                setQuestionCreateLoad(false)
                let payload = {
                    action: "getCustomFormById",
                    form_id: formId,
                    client_user_id: clientId
                }
                dispatch(getCustomFormById(payload))
            }
        )
    }

    function updateQuestion() {
        if (!questionText) {
            return alert("Question text required")
        }
        if (!chosenCategory) {
            return alert("category required")
        }
        if (!chosenAnswerType) {
            return alert("Answer type required")
        }

        let payload = {
            "question": questionText,
            "question_number": questionToEdit.question_number,
            "form_id": formId,
            "category_id": chosenCategory?.value,
            "answer_type_id": chosenAnswerType,
            "placeholder_text": placeholderText,
            "question_id": questionId,
            "question_user_id_number": questionToEdit.question_user_id_number,
            action: "updateFormQuestion"
        }

        if (chosenSubAnswerType) {
            payload.second_answer_type_id = chosenSubAnswerType
            payload.second_placeholder_text = subPlaceholderText
        } else if (measurement) {
            payload.second_answer_type_id = measurement;
        }

        setQuestionUpdateLoad(true)
        statusDispatch(updateFormQuestion(payload), "question", "update").then(
            res => {
                setQuestionToEdit(null);
                setShowQuestionModal(false)
                setQuestionUpdateLoad(false)
                let payload = {
                    action: "getCustomFormById",
                    form_id: formId,
                    client_user_id: clientId
                }
                dispatch(getCustomFormById(payload))
            }
        )
    }

    function clearOptions() {
        setMeasurement("");
        setChosenSubAnswerType("");
        setPlaceholderText("");
        setSubPlaceholderText("");
    }




    const MenuList = ({ children, ...props }) => {
        return (
            <components.MenuList {...props}>
                <div >
                    <i className="ml-2 m-0 pt-3 fa fa-info-circle">  </i> <span><i> To create a new category, enter a unique name above </i> </span>
                    <hr />


                </div>
                {children}

            </components.MenuList>

        );
    };

    const handleCategoryDelete = (categoryId, categoryName) => {
        if (window.confirm(`are you sure you want to delete category "${categoryName}?"`)) {
            let payload = { category_id: categoryId };
            statusDispatch(removeFormCategory(payload), "question category", "delete")
        }
    }

    const deleteCategoryPopover = (
        <Popover id="popover-basic">
            <Popover.Content>
                {categories?.filter(category => category.id != "0").map(category => {
                    return (
                        <div style={{ display: "inline-block", position: "relative" }}>
                            <span
                                className={classes.categoryDelete}
                                onClick={() => {
                                    handleCategoryDelete(category.id, category.category_name)
                                }}
                            > x </span>
                            <span
                                className={[classes.category].join(' ')}>
                                {category.category_name}
                            </span>

                        </div>)
                })}
            </Popover.Content>
        </Popover >

    )

    return (
        <Modal
            onHide={() => {
                setShowQuestionModal(false); setQuestionToEdit(null);
            }}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            show={showQuestionModal}
        >
            <Modal.Header className="flex-column">
                <Modal.Title id="contained-modal-title-vcenter">
                    {questionToEdit ? <span> Edit Question </span> : <span> Add Question</span>}
                </Modal.Title>
                <br />
                {questionToEdit &&
                    <div>
                        <i
                            className="fas fa-info-circle mx-2"
                            style={{ color: "#525F7F" }}
                        ></i>
                        <i> Editing existing answer formats will cause any saved client answers to be lost </i>
                    </div>}

            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Label> Question </Form.Label>
                    <Form.Control as="textarea" rows={3} value={questionText} onChange={(e) => setQuestionText(e.target.value)} />
                </Form.Group>
                <Form.Group className="mb-0">
                    <Form.Label>
                        Category
                    </Form.Label>
                    <CreatableSelect
                        isClearable
                        className="w-100 mr-1"
                        value={chosenCategory}
                        isDisabled={categoryIsLoading}
                        isLoading={categoryIsLoading}
                        onChange={category => {
                            setChosenCategory(category)
                            setNewCategory(false);

                        }}
                        components={{ MenuList }}
                        options={
                            categories?.filter(category => category.id != "0").map(
                                category => ({
                                    value: category.id,
                                    label: category.category_name
                                })
                            )}
                        onCreateOption={(new_category) => {
                            let payload = {
                                action: "createFormCategory",
                                new_category,
                            }
                            setNewCategory(false);
                            setCategoryIsLoading(true)
                            dispatch(createFormCategory(payload)).then(
                                res => {
                                    setCategoryIsLoading(false);
                                    let category_name = res.payload.data.category_name
                                    let category_id = res.payload.data.category_id
                                    setChosenCategory({
                                        value: category_id,
                                        label: category_name
                                    })
                                }
                            )
                        }}
                    />
                </Form.Group >
                <div className="mb-2 pl-0 ml-0">
                    <OverlayTrigger
                        trigger="click"
                        placement="top"
                        overlay={deleteCategoryPopover}
                        rootCloseEvent="click"
                        rootClose={true}
                    >
                        <Button className="text-danger" variant={"Link"} > delete a category</Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        overlay={
                            <Tooltip>
                                Only unused categories can be deleted
                            </Tooltip>
                        }>
                        <i className={`fa fa-info-circle ${classes.infoCircle}`}> </i>
                    </OverlayTrigger>
                </div>

                <Form.Group>
                    <Form.Label> Answer Format:</Form.Label>
                    <Form.Control as="select"
                        value={chosenAnswerType}
                        className="input-group-text"
                        onChange={e => {
                            setChosenAnswerType(e.target.value)
                            clearOptions();
                        }}
                    >
                        <option value="" >Choose here</option>
                        {tempAnswerTypes?.map((answerType => {
                            let answerTypeText;
                            let ignoreTypes = ["Hardcoded", "in=0,cm=1", "lbs=0,kg=1"]

                            if (ignoreTypes.includes(answerType.answer_type)) {
                                return
                            }

                            switch (answerType.answer_type) {
                                case "Yes=1,No=0":
                                    answerTypeText = "Yes, No"
                                    break;
                                case "Yes=1,No=0,Unsure=2":
                                    answerTypeText = "Yes, No, Unsure"
                                    break;
                                case "Never Taken=1,Normal=0,Abnormal=2":
                                    answerTypeText = "Never Taken, Normal, Abnormal"
                                    break;
                                case "None":
                                    answerTypeText = "Statement/Explanation (not answerable)";
                                    break;
                                default:
                                    answerTypeText = answerType.answer_type
                            }
                            return (
                                <option key={answerType.id} value={answerType.id}> {answerTypeText}</option>
                            )
                        }))}
                    </Form.Control>
                </Form.Group>
                {chosenAnswerType == "3" && <Form.Group>
                    <Form.Label> Textfield placeholder (optional) </Form.Label>
                    <Form.Control type="text" value={placeholderText} onChange={(e) => setPlaceholderText(e.target.value)} />
                </Form.Group>}

                {(chosenAnswerType == "1" || chosenAnswerType == "2") &&
                    <Form.Group>
                        <Form.Label> Additional Answer Format (optional) </Form.Label>
                        <Form.Control as="select"
                            value={chosenSubAnswerType}
                            className="input-group-text"
                            onChange={e => {
                                setSubPlaceholderText("");
                                setMeasurement("");
                                setChosenSubAnswerType(e.target.value)
                            }}
                        >
                            <option value="" >Choose here</option>
                            {tempAnswerTypes?.map((answerType => {
                                let answerTypeText;

                                let ignoreTypes = ["Hardcoded", "in=0,cm=1", "lbs=0,kg=1", "None", "Yes=1,No=0", "Yes=1,No=0,Unsure=2"];

                                if (ignoreTypes.includes(answerType.answer_type)) {
                                    return
                                }

                                switch (answerType.answer_type) {
                                    case "Never Taken=1,Normal=0,Abnormal=2":
                                        answerTypeText = "Never Taken, Normal, Abnormal"
                                        break;
                                    default:
                                        answerTypeText = answerType.answer_type
                                }

                                return (
                                    <option key={answerType.id} value={answerType.id}> {answerTypeText}</option>
                                )
                            }))}
                        </Form.Control>
                    </Form.Group>}
                {/*textfield answer */}
                {chosenSubAnswerType == "3" && (chosenAnswerType == "1" || chosenAnswerType === "2") && <Form.Group>
                    <Form.Label> Additional Textfield placeholder (optional) </Form.Label>
                    <Form.Control type="text" value={subPlaceholderText} onChange={(e) => setSubPlaceholderText(e.target.value)} />
                </Form.Group>}

                {/*textfield answer */}
                {chosenAnswerType == "8" &&
                    <Form.Group>
                        <Form.Label> Add Measurement (optional) </Form.Label>
                        <Form.Control as="select"
                            value={measurement}
                            className="input-group-text"
                            onChange={e => {
                                setMeasurement(e.target.value)
                            }}
                        >
                            <option value="">Choose here</option>
                            <option key={'9'} value={'9'}> inches/centimeter </option>
                            <option key={'10'} value={'10'}> pounds/kilograms</option>
                        </Form.Control>
                    </Form.Group>}

            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={() => {
                    setShowQuestionModal(false); setQuestionToEdit(null);
                }}>Close</Button>
                {(questionUpdateLoad) ?
                    <Button>
                        <Spinner animation="border" role="status" size={"sm"}>
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </Button> :
                    questionToEdit && <Button onClick={() => updateQuestion()}>Update</Button>}

                {(questionCreateLoad ? <Button>
                    <Spinner animation="border" role="status" size={"sm"}>
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </Button> :
                    !questionToEdit && <Button onClick={() => createQuestion()} variant="success">Create</Button>)}
            </Modal.Footer>
        </Modal >
    );
}

export default QuestionModal;